export default {
  init() {
    // JavaScript to be fired on all pages
    $('.js-slick').slick({
      autoplay: true,
      autoplaySpeed: 6000,
      fade: true,
    });

    $(window).on('load', function () {
      $('.p-front-page_works__list-item:nth-of-type(1)').addClass('is-active');
      setTimeout(function () {
        $('.p-front-page_works__list-item:nth-of-type(1)').removeClass('is-active');
      }, 6000);
    });

    $('.js-slick').on('beforeChange', function () {
      $('.p-front-page_works__list-item.slick-slide.slick-current.slick-active').removeClass('is-active');
    });

    $('.js-slick').on('afterChange', function () {
      $('.p-front-page_works__list-item.slick-slide.slick-current.slick-active').addClass('is-active');
    });

    $('.js-slick2').slick({
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      variableWidth: true,
      centerMode: true,
      focusOnSelect: true,
    });

    $('.js-company-tab--primary').on('click', function () {
      $('.js-company-tab--primary').addClass('is-current');
      $('.js-company-tab--secondary').removeClass('is-current');
      $('.p-aboutus_outline').fadeIn();
      $('.p-aboutus_history').fadeOut();
      return false;
    });

    $('.js-company-tab--secondary').on('click', function () {
      $('.js-company-tab--primary').removeClass('is-current');
      $('.js-company-tab--secondary').addClass('is-current');
      $('.p-aboutus_outline').fadeOut();
      $('.p-aboutus_history').fadeIn();
      return false;
    });

    $('.js-btn-open-csr').on('click', function () {
      $('.c-full-screen-visual-layout__default-hide').fadeIn();
      $('.js-btn-open-csr').fadeOut();
      $('.js-btn-close-csr').fadeIn();
      return false;
    });

    $('.js-btn-close-csr').on('click', function () {
      $('.c-full-screen-visual-layout__default-hide').fadeOut();
      $('.js-btn-open-csr').fadeIn();
      $('.js-btn-close-csr').fadeOut();
      return false;
    });



    $('.btn-open--produce-concept').on('click', function () {
      $('.c-full-screen-visual-layout__default-hide--produce-concept').fadeIn();
      $('.btn-open--produce-concept').fadeOut();
      return false;
    });

    $('.btn-close--produce-concept').on('click', function () {
      $('.c-full-screen-visual-layout__default-hide--produce-concept').fadeOut();
      $('.btn-open--produce-concept').fadeIn();
      return false;
    });

    $('.btn-open--alliance-service-network').on('click', function () {
      $('.c-full-screen-visual-layout__default-hide--alliance-service-network').fadeIn();
      $('.btn-open--alliance-service-network').fadeOut();
      return false;
    });

    $('.btn-close--alliance-service-network').on('click', function () {
      $('.c-full-screen-visual-layout__default-hide--alliance-service-network').fadeOut();
      $('.btn-open--alliance-service-network').fadeIn();
      return false;
    });

    $('.js-works-navigation01').on('change', function () {
      var val01 = '';
      if ($('.js-works-navigation01').val() !== '') {
        val01 = '.' + $('.js-works-navigation01').val();
      }
      var val02 = '';
      if ($('.js-works-navigation02').val() !== '') {
        val02 = '.' + $('.js-works-navigation02').val();
      }
      $('.c-works__item-wrap').fadeOut();
      $('.c-works__item-wrap' + val01 + val02).fadeIn();
      return false;
    });

    $('.js-works-navigation02').on('change', function () {
      var val01 = '';
      if ($('.js-works-navigation01').val() !== '') {
        val01 = '.' + $('.js-works-navigation01').val();
      }
      var val02 = '';
      if ($('.js-works-navigation02').val() !== '') {
        val02 = '.' + $('.js-works-navigation02').val();
      }
      $('.c-works__item-wrap').fadeOut();
      $('.c-works__item-wrap' + val01 + val02).fadeIn();
      return false;
    });

    $('#menuBtn').click(function () {
      $('#menuBtn').toggleClass('open');
      if ($('#menuBtn').hasClass('open')) {
        $('#nav-icon').addClass('open');
        $('#mainNav').addClass('open');
        $('#spNavOpenBg').addClass('open');
      } else {
        $('#nav-icon').removeClass('open');
        $('#mainNav').removeClass('open');
        $('#spNavOpenBg').removeClass('open');
      }
    });
    // menuBtn
    var wWidth = $(window).width();
    if (wWidth > 750) {
      if ($('#menuBtn').hasClass('open')) { $('#menuBtn').removeClass('open') }
      if ($('#nav-icon').hasClass('open')) { $('#nav-icon').removeClass('open') }
      if ($('#mainNav').hasClass('open')) { $('#mainNav').removeClass('open') }
      if ($('#spNavOpenBg').hasClass('open')) { $('#spNavOpenBg').removeClass('open') }
    }

    var h = $(window).height();
    // $('#loadingWrap').css('display','none');
    $('#loader-bg ,#loader').height(h).css('display', 'block');
    $('#loader img').delay(800).fadeIn(500);
    // $('#loader p').delay(800).fadeIn(500);

    $(window).load(function () {
      $('#loader-bg').delay(900).fadeOut(800);
      $('#loader').delay(600).fadeOut(300);
      // $('#loadingWrap').css('display', 'block');
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js